import React, { useState, useRef } from "react";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import FlexSlide from "./FlexSlide";
import ImagenValidada from "../ActividadesUtils/RecursosValidados/ImagenValidada";
import PlaceholderMedia from "../../PlaceholderMedia";

const FlexSlider = ({ carouselData, instrucciones, isGeneratingPDF = false }) => {
  const [currentSlide, setCurrentSlide] = useState(2);

  // Solo mostrar placeholder si se pasa explícitamente isGeneratingPDF
  const reemplazarRecursos = new URLSearchParams(window.location.search).get('reemplazarRecursos') === 'true';

  const responsive = {
    desktop: {
      breakpoint: { max: 10000, min: 1024 },
      items: 1,
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 1,
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1,
    },
  };

  const orderedData = carouselData.sort((a, b) => {
    if (a.orden > b.orden) {
      return 1;
    } else {
      return -1;
    }
  });

  // En modo PDF, el carrusel interactivo solo deja ver (y por lo tanto
  // capturar) la diapositiva actual: aquí se listan todos los elementos uno
  // debajo del otro para que ninguno se pierda en el documento estático.
  // Sin aspect-ratio ni object-cover: la imagen se muestra completa, a su
  // proporción natural, sin recortarse. "carrusel-pdf-items" marca el
  // contenedor para que cada diapositiva (imagen + texto) se pagine como una
  // sola pieza y nunca se separen entre páginas distintas.
  if (isGeneratingPDF) {
    return (
      <>
        <div className="mt-4 lg:mt-8"></div>
        {instrucciones && (
          <div className="block-instructions lg:mt-8 mb-2">{instrucciones}</div>
        )}
        <div className="w-full carrusel-pdf-items">
          {orderedData.map((item, index) => (
            <div key={index} className="mb-8">
              {item.imagen && (
                <ImagenValidada
                  src={item.imagen}
                  className="mx-auto block w-full max-w-md rounded-md border"
                />
              )}
              {(item.video || item.audio) && (
                <PlaceholderMedia
                  tipo={item.video ? "video" : "audio"}
                  nombreArchivo={reemplazarRecursos ? (item.video || item.audio) : null}
                />
              )}
              {item.texto && (
                <div className="text-gray-700 text-justify text-sm mt-2">{item.texto}</div>
              )}
            </div>
          ))}
        </div>
      </>
    );
  }

  return (
    <>
      <div className="mt-4 lg:mt-8"></div>
      {instrucciones && (
        <div className="block-instructions lg:mt-8 mb-2">{instrucciones}</div>
      )}
      <Carousel
        centerMode
        ssr
        responsive={responsive}
        showDots={false}
        keyBoardControl={true}
        infinite
        className="mb-[2rem] z-[5] flex-carousel"
        afterChange={(nextSlide, { currentSlide, onMove }) => {
          setCurrentSlide(currentSlide);
        }}
      >
        {orderedData.map((item, index) => (
          <>
            <FlexSlide
              slideData={item}
              key={index}
              currentSlide={currentSlide}
              index={index}
            />
          </>
        ))}
      </Carousel>
    </>
  );
};

export default FlexSlider;
